import { IconProps } from "./icon.type";

export function IcGlassBusiness(props: IconProps) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3200_44929)">
        <rect width="40" height="40" rx="8" fill="white" />
        <foreignObject x="-64.08" y="-68.4799" width="170.96" height="170.96">
          <div
            style={{
              backdropFilter: "blur(17.64px)",
              clipPath: "url(#bgblur_1_3200_44929_clip_path)",
              height: "100%",
              width: "100%",
            }}
          ></div>
        </foreignObject>
        <circle
          data-figma-bg-blur-radius="35.28"
          cx="21.4"
          cy="17"
          r="50.2"
          fill="url(#paint0_radial_3200_44929)"
          fillOpacity="0.3"
        />
        <foreignObject x="6.99326" y="3.8021" width="17.6138" height="29.5772">
          <div
            style={{
              backdropFilter: "blur(0.8px)",
              clipPath: "url(#bgblur_2_3200_44929_clip_path)",
              height: "100%",
              width: "100%",
            }}
          ></div>
        </foreignObject>
        <path
          data-figma-bg-blur-radius="1.6"
          d="M23.0071 31.7793H8.59326V14.5485C8.59326 14.016 8.85827 13.5183 9.30018 13.221L20.514 5.67716C21.5768 4.96217 23.0071 5.72377 23.0071 7.00472V31.7793Z"
          fill="url(#paint1_linear_3200_44929)"
          fillOpacity="0.5"
        />
        <foreignObject x="6.49288" y="18.6718" width="13.1114" height="15.2081">
          <div
            style={{
              backdropFilter: "blur(2.62px)",
              clipPath: "url(#bgblur_3_3200_44929_clip_path)",
              height: "100%",
              width: "100%",
            }}
          ></div>
        </foreignObject>
        <rect
          data-figma-bg-blur-radius="5.2454"
          x="14.3067"
          y="23.9694"
          width="4.61293"
          height="2.51638"
          rx="1.25819"
          transform="rotate(90 14.3067 23.9694)"
          fill="url(#paint2_linear_3200_44929)"
          stroke="url(#paint3_linear_3200_44929)"
          strokeWidth="0.104314"
        />
        <foreignObject x="6.49288" y="11.3339" width="13.1114" height="15.2081">
          <div
            style={{
              backdropFilter: "blur(2.62px)",
              clipPath: "url(#bgblur_4_3200_44929_clip_path)",
              height: "100%",
              width: "100%",
            }}
          ></div>
        </foreignObject>
        <rect
          data-figma-bg-blur-radius="5.2454"
          x="14.3067"
          y="16.6315"
          width="4.61293"
          height="2.51638"
          rx="1.25819"
          transform="rotate(90 14.3067 16.6315)"
          fill="url(#paint4_linear_3200_44929)"
          stroke="url(#paint5_linear_3200_44929)"
          strokeWidth="0.104314"
        />
        <foreignObject x="12.2585" y="18.6718" width="13.1114" height="15.2081">
          <div
            style={{
              backdropFilter: "blur(2.62px)",
              clipPath: "url(#bgblur_5_3200_44929_clip_path)",
              height: "100%",
              width: "100%",
            }}
          ></div>
        </foreignObject>
        <rect
          data-figma-bg-blur-radius="5.2454"
          x="20.0724"
          y="23.9694"
          width="4.61293"
          height="2.51638"
          rx="1.25819"
          transform="rotate(90 20.0724 23.9694)"
          fill="url(#paint6_linear_3200_44929)"
          stroke="url(#paint7_linear_3200_44929)"
          strokeWidth="0.104314"
        />
        <foreignObject x="12.2585" y="11.3339" width="13.1114" height="15.2081">
          <div
            style={{
              backdropFilter: "blur(2.62px)",
              clipPath: "url(#bgblur_6_3200_44929_clip_path)",
              height: "100%",
              width: "100%",
            }}
          ></div>
        </foreignObject>
        <rect
          data-figma-bg-blur-radius="5.2454"
          x="20.0724"
          y="16.6315"
          width="4.61293"
          height="2.51638"
          rx="1.25819"
          transform="rotate(90 20.0724 16.6315)"
          fill="url(#paint8_linear_3200_44929)"
          stroke="url(#paint9_linear_3200_44929)"
          strokeWidth="0.104314"
        />
        <path
          d="M24.3171 31.7794V18.1519H30.0551C30.9387 18.1519 31.6551 18.8682 31.6551 19.7519V31.7794H24.3171Z"
          fill="url(#paint10_linear_3200_44929)"
        />
        <rect
          x="4.20039"
          y="32.1035"
          width="31.3241"
          height="2.49655"
          rx="1.24828"
          fill="url(#paint11_linear_3200_44929)"
          fillOpacity="0.5"
          stroke="url(#paint12_linear_3200_44929)"
          strokeWidth="0.4"
        />
      </g>
      <defs>
        <clipPath id="bgblur_1_3200_44929_clip_path" transform="translate(64.08 68.4799)">
          <circle cx="21.4" cy="17" r="50.2" />
        </clipPath>
        <clipPath id="bgblur_2_3200_44929_clip_path" transform="translate(-6.99326 -3.8021)">
          <path d="M23.0071 31.7793H8.59326V14.5485C8.59326 14.016 8.85827 13.5183 9.30018 13.221L20.514 5.67716C21.5768 4.96217 23.0071 5.72377 23.0071 7.00472V31.7793Z" />
        </clipPath>
        <clipPath id="bgblur_3_3200_44929_clip_path" transform="translate(-6.49288 -18.6718)">
          <rect
            x="14.3067"
            y="23.9694"
            width="4.61293"
            height="2.51638"
            rx="1.25819"
            transform="rotate(90 14.3067 23.9694)"
          />
        </clipPath>
        <clipPath id="bgblur_4_3200_44929_clip_path" transform="translate(-6.49288 -11.3339)">
          <rect
            x="14.3067"
            y="16.6315"
            width="4.61293"
            height="2.51638"
            rx="1.25819"
            transform="rotate(90 14.3067 16.6315)"
          />
        </clipPath>
        <clipPath id="bgblur_5_3200_44929_clip_path" transform="translate(-12.2585 -18.6718)">
          <rect
            x="20.0724"
            y="23.9694"
            width="4.61293"
            height="2.51638"
            rx="1.25819"
            transform="rotate(90 20.0724 23.9694)"
          />
        </clipPath>
        <clipPath id="bgblur_6_3200_44929_clip_path" transform="translate(-12.2585 -11.3339)">
          <rect
            x="20.0724"
            y="16.6315"
            width="4.61293"
            height="2.51638"
            rx="1.25819"
            transform="rotate(90 20.0724 16.6315)"
          />
        </clipPath>
        <radialGradient
          id="paint0_radial_3200_44929"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.7107 21.4822) rotate(116.852) scale(41.1049)"
        >
          <stop offset="0.259615" stopColor="#3ED5FF" />
          <stop offset="0.903846" stopColor="#A1CAFF" stopOpacity="0" />
        </radialGradient>
        <linearGradient
          id="paint1_linear_3200_44929"
          x1="19.0175"
          y1="6.4803"
          x2="2.5814"
          y2="22.0138"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1BF1FF" />
          <stop offset="1" stopColor="#0155FD" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3200_44929"
          x1="18.8396"
          y1="24.5555"
          x2="18.6764"
          y2="27.0357"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9FFFC" />
          <stop offset="1" stopColor="#F7FBFF" stopOpacity="0.28" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3200_44929"
          x1="15.3999"
          y1="27.1613"
          x2="17.6888"
          y2="23.1858"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3200_44929"
          x1="18.8396"
          y1="17.2176"
          x2="18.6764"
          y2="19.6978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9FFFC" />
          <stop offset="1" stopColor="#F7FBFF" stopOpacity="0.28" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3200_44929"
          x1="15.3999"
          y1="19.8234"
          x2="17.6888"
          y2="15.8479"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3200_44929"
          x1="24.6052"
          y1="24.5555"
          x2="24.442"
          y2="27.0357"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9FFFC" />
          <stop offset="1" stopColor="#F7FBFF" stopOpacity="0.28" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_3200_44929"
          x1="21.1655"
          y1="27.1613"
          x2="23.4545"
          y2="23.1858"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_3200_44929"
          x1="24.6052"
          y1="17.2176"
          x2="24.442"
          y2="19.6978"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9FFFC" />
          <stop offset="1" stopColor="#F7FBFF" stopOpacity="0.28" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_3200_44929"
          x1="21.1655"
          y1="19.8234"
          x2="23.4545"
          y2="15.8479"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_3200_44929"
          x1="32.2"
          y1="17.2001"
          x2="16.4066"
          y2="27.6142"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42DBE5" />
          <stop offset="1" stopColor="#0155FD" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_3200_44929"
          x1="26.7652"
          y1="32.4907"
          x2="26.6728"
          y2="34.9721"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42DBE5" />
          <stop offset="1" stopColor="#0155FD" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_3200_44929"
          x1="6.58329"
          y1="32.4684"
          x2="6.80514"
          y2="35.9672"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_3200_44929">
          <rect width="40" height="40" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
